import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Botão flutuante das telas longas (sj-rolar): leva ao fim da página ou volta ao
 * topo. Observa a área de conteúdo (`#conteudo-principal`), que é quem rola.
 */
export default function BotaoRolar() {
  const { pathname } = useLocation();
  const [longa, setLonga] = useState(false);
  const [noTopo, setNoTopo] = useState(true);

  useEffect(() => {
    const area = document.getElementById('conteudo-principal');
    if (!area) return undefined;
    const medir = () => {
      setLonga(area.scrollHeight > area.clientHeight * 1.4);
      setNoTopo(area.scrollTop < 160);
    };
    medir();
    const tempo = setTimeout(medir, 400);
    area.addEventListener('scroll', medir, { passive: true });
    window.addEventListener('resize', medir);
    const observador = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(medir) : null;
    if (observador && area.firstElementChild) observador.observe(area.firstElementChild);
    return () => {
      clearTimeout(tempo);
      area.removeEventListener('scroll', medir);
      window.removeEventListener('resize', medir);
      if (observador) observador.disconnect();
    };
  }, [pathname]);

  if (!longa) return null;

  const rotulo = noTopo ? 'Ir para o fim da página' : 'Voltar ao topo';
  const rolar = () => {
    const area = document.getElementById('conteudo-principal');
    if (area) area.scrollTo({ top: noTopo ? area.scrollHeight : 0, behavior: 'smooth' });
  };

  return (
    <button className="sj-rolar" type="button" aria-label={rotulo} title={rotulo} onClick={rolar}>
      <span className="sj-icone" aria-hidden="true">{noTopo ? 'arrow_downward' : 'arrow_upward'}</span>
    </button>
  );
}
